<template>
  <div>
    <div v-if="$auth.policies['view-meal-config']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <Breadcrumbs :headline="pageTitle" :link="[{ text: 'Dịch vụ bếp', href: '#' }, { text: pageTitle }]" />
        <v-btn depressed dark color="#0D47A1" @click="$refs.formDialog.openCreate()">
          <v-icon left>add</v-icon>Thêm bữa
        </v-btn>
      </div>

      <v-card outlined class="mx-4 elevation-0">
        <v-data-table :headers="headers" :items="slots" :loading="loading" :items-per-page="20">
          <template v-slot:[`item.timeOfDay`]="{ item }">{{ timeOfDayLabel(item.timeOfDay) }}</template>
          <template v-slot:[`item.schedule`]="{ item }">
            <span v-if="item.type === 'fixed'">{{ serveDaysLabel(item.serveDays) }}</span>
            <span v-else>{{ item.serveDate | ddmmyyyy }}</span>
          </template>
          <template v-slot:[`item.menuCount`]="{ item }">{{ item.menuCount }}</template>
          <template v-slot:[`item.maxPortion`]="{ item }">{{ item.maxPortion }}</template>
          <template v-slot:[`item.fee`]="{ item }">
            {{ item.feeType === 'free' ? feeTypeLabel('free') : formatMoney(item.feeAmount) }}
          </template>
          <template v-slot:[`item.applicationCount`]="{ item }">{{ item.applicationCount != null ? item.applicationCount : '-' }}</template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn icon small color="primary" title="Chi tiết / Cấu hình" :to="`/meal-slots/${item.id}`">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <MealSlotFormDialog ref="formDialog" :type="type" @saved="onCreated" />
    </div>
    <Page403 v-else />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Page403 from '@/views/Page403.vue'
import MealSlotFormDialog from '@/modules/mealConfig/meal-slot/MealSlotFormDialog'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { timeOfDayLabel, serveDaysLabel, feeTypeLabel, mealTypeFullLabel } from '@/modules/mealConfig/mealConfigConstants'

export default {
  components: { Breadcrumbs, Page403, MealSlotFormDialog },
  filters: {
    ddmmyyyy(v) {
      return v ? moment(v).format('DD/MM/YYYY') : ''
    }
  },
  computed: {
    ...mapState('mealSlot', ['slots', 'loading']),
    type() {
      return this.$route.name === 'supplementary-meals' ? 'supplementary' : 'fixed'
    },
    pageTitle() {
      return mealTypeFullLabel(this.type)
    },
    headers() {
      return [
        { text: 'Tên bữa', value: 'title' },
        { text: 'Thời điểm', value: 'timeOfDay', sortable: false },
        { text: this.type === 'fixed' ? 'Ngày phục vụ' : 'Ngày', value: 'schedule', sortable: false },
        { text: 'Số menu', value: 'menuCount', sortable: false, align: 'center' },
        { text: 'Suất tối đa', value: 'maxPortion', sortable: false, align: 'center' },
        { text: 'Số nhóm áp dụng', value: 'applicationCount', sortable: false, align: 'center' },
        { text: 'Biểu phí', value: 'fee', sortable: false },
        { text: 'Thao tác', value: 'action', sortable: false, align: 'center' }
      ]
    }
  },
  watch: {
    '$route.name'() {
      this.refresh()
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    ...mapActions('mealSlot', ['fetchList']),
    timeOfDayLabel,
    serveDaysLabel,
    feeTypeLabel,
    formatMoney(v) {
      return (v || 0).toLocaleString('vi-VN') + ' đ'
    },
    refresh() {
      return this.fetchList({ type: this.type }).catch(e => this.$alert.error('Không tải được danh sách: ' + e))
    },
    onCreated(slot) {
      if (slot && slot.id) this.$router.push(`/meal-slots/${slot.id}`)
      else this.refresh()
    }
  }
}
</script>
